import React from 'react';
import Select from 'react-select';

export default class ProviderDropdown extends React.Component {

  constructor(props) {
    super(props);

    this.state.selectedOption = props.selectedProvider;
  }

  state = {
    selectedOption: null,
    options: [],
  };

  handleChange = (event) => {
    this.setState({
      selectedOption: event,
    });

    this.props.handleProviderChange(event);
  }

  render() {
    const data = [];
    let isDisable = true;
    this.props.providers.forEach(provider => {
      const p = {
        value: provider.providerId,
        label: provider.providerName,
        provider: provider,
        required: true,
      };
      data.push(p);
    });

    if (data.length > 0 && !this.props.disabled) {
      isDisable = false;
    }

    const selectProviderStyles = {
      option: (styles, { isDisabled }) => {
        return {
          ...styles,
          color: '#394b59',
          cursor: isDisabled ? 'not-allowed' : 'default',

          ':active': {
            ...styles[':active'],
          },
        };
      },
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return { ...provided, opacity, transition };
      },
      placeholder: (state) => ({
        color: state.isSelected ? 'black' : '#394b59',
      })

    }

    const selectedProvider = data.find(d => d.provider === this.props.selectedProvider);

    return (
      <Select
        isMulti={this.props.isMulti}
        isClearable={this.props.isClearable}
        styles={selectProviderStyles}
        value={selectedProvider}
        onChange={this.handleChange}
        options={data}
        isDisabled={isDisable}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: 'lightgrey',
          },
        })}
      />

    );
  }
}
